<template>
    <div>
        <loading :active.sync="bool_fullLoading"></loading>
        <div class="container-fluid">
            <CRow class="align-items-center  my-1">
                <div class="col-12 d-flex ">
                    <div class="quicklink position-relative">
                        <a href="#" class="active">
                            {{this.getLanguage['DB']['N']}}
                        </a>

                        <div style=" color: rgb(255, 255, 255); font-size: 1.25rem; position: absolute; right: 25px; top: 50%; transform: translate(0%, -50%); " @click="ReadAll()" v-if="arry_cl.length > 0">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#cc0000" style="width: 28px;height: 28px;">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier"> <path d="M4 12.9L7.14286 16.5L15 7.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20 7.5625L11.4283 16.5625L11 16" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                            </svg>
                        </div>
                        <img class="img-fluid float-right" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_earth-19.svg" width="20" style="position: absolute; right: 0; top: 50%; transform: translate(0%, -50%); " @click="slideinsearchfilter ? slideinsearchfilter = false:slideinsearchfilter = true">
                    </div>
                </div>
            </CRow>

            <CRow>
                <CCol col="12">
                    <div class="record-header">
                        <div class="">
                            {{getLanguage['ASN']['NT']}} /  {{getLanguage['GL']['DT']}}
                        </div>
                        <div class="text-right">
                            {{getLanguage['GL']['S']}}
                        </div>
                    </div>
                    <div class="nodata-record" v-if="arry_cl.length == 0">
                        <div>
                            <img class="img-fluid" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_norecord.svg" width="125">
                            <span class="d-block" style="margin-top: -17px;"> {{this.getLanguage['GL']['NR']}}</span>
                        </div>
                    </div>
                    <div class="record-item" v-for="(data,index) in arry_cl" @click="slideInNotifDetail(data);Read(index, data.IR, data.I)">
                        <div>
                            <div class="font-weight-bold text-white">{{data.T}}</div>
                            <div class="record-desc">
                                <template v-if="data.CTS">
                                    {{data.CTS | moment('DD MMM YYYY HH:mm:ss')}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </div>
                        </div>
                        <div class="text-right">
                            <div class="" :class="data.IR ? 'text-success' : 'text-danger'">{{ data.IR ? getLanguage["NOTI"]["READ"] : getLanguage["NOTI"]["UNREAD"] }}</div>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div :class="slideinsearchfilter || slideindetail ? 'slideinoverlay': ''" @click="slideindetail= false;slideinsearchfilter = false;"></div>
            <div class="sliding-div" :class="{ 'is-visible': slideinsearchfilter }" @click.stop style="height:85%">
                <div class="position-relative h-100 overflow-auto">
                    <div class='searchBox'>
                        <div class='searchCol'>
                            <span class='searchLabel'>{{ getLanguage["NOTI"]["AC"] }} :</span>
                            <CInput size="sm"
                                    :value="searchC" :placeholder="getLanguage['AN']['SH']"
                                    @change="v => searchC = v" />
                        </div>
                    </div>

                    <div class="btngroup">
                        <CButton block color="secondary" class='font-weight-bold m-0' @click="searchC = null;"><span>{{this.getLanguage['BTN']['RS']}}</span></CButton>
                        <CButton block color="success" class='font-weight-bold m-0' @shortkey="newSearch()" @click="newSearch()" ref="search"><span>{{this.getLanguage['GL']['CONFIRM']}}</span></CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideindetail }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{ obj_cl.T }}</h2>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{getLanguage['GL']['DT']}} </div>
                        <div class="sliding-item-desc">
                            <template v-if="obj_cl.CTS">
                                {{obj_cl.CTS | moment('DD MMM YYYY HH:mm:ss')}}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">  {{getLanguage['GL']['S']}} </div>
                        <div class="sliding-item-desc" :class="obj_cl.IR ? 'text-success' : 'text-danger'">{{ obj_cl.IR ? getLanguage["NOTI"]["READ"] : getLanguage["NOTI"]["UNREAD"] }}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{getLanguage['ACU']['DES']}} </div>
                        <div class="sliding-item-desc">{{obj_cl.CBD }}</div>
                    </div>

                  
                    <div class="slidlingbtn">
                        <CButton color="success" block @click="slideindetail = false">
                            {{this.getLanguage["BTN"]["CLO"]}}
                        </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from 'vue-loading-overlay';
    import moment from "moment";

    export default {
        mixins: [genericHelper],
        components: {
            Loading
        },
        data() {
            return {
                collapse: -1,
                arry_cl: {},
                obj_cl: {},
                arry_setIsRead_List: [],
                bool_fullLoading: false,
                bool_showSearchBar: false,
                //the parameter of getList()
                int_Page: 1,//current Page
                int_IC: 1, //Item Count
                int_RC: 200, //Row Count
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Descending
                str_FV: "", //Filter Value

                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 0, //Total Page

                //date
                ND_List: [],

                searchC: null, //Filter Value
                slideinsearchfilter: false,
                slideindetail: false,

            }
        },
        methods: {
            slideInNotifDetail(data) {
                this.slideindetail = true;
                this.obj_cl = data;
            },
            ReadAll() {
                this.arry_cl.forEach((value, key) => {
                    if (!value.IR) {
                        var that = this;
                        this.getDataApi(`/api/anotif/ga/${value.I}`,
                            function (d, s) {
                                if (s) {
                                    that.getNotifList();
                                }
                            });
                    }
                });
            },
            Read(index, bool_IR, Id) {
                if (this.collapse != index) {
                    this.collapse = index;
                } else {
                    this.collapse = -1;
                }

                if (!bool_IR) {
                    var that = this;
                    this.getDataApi(`/api/anotif/ga/${Id}`,
                        function (d, s) {
                            if (s) {
                                that.getNotifList();
                            }
                        });
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                } else {
                    return value;
                }
            },
            //FormatNotifTime(date){
            //    return moment(date).fromNow();
            //},
            FormatNotifTime(loginDateTime, currentTime) {
                let d = (new Date(currentTime)) - (new Date(loginDateTime));
                let W = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
                let DDAY = Math.floor(d / 1000 / 60 / 60 / 24 - W * 7);
                let DHR = Math.floor(d / 1000 / 60 / 60 - W * 7 * 24 - DDAY * 24);
                let DMT = Math.floor(d / 1000 / 60 - W * 7 * 24 * 60 - DDAY * 24 * 60 - DHR * 60);
                let DSC = Math.floor(d / 1000 - W * 7 * 24 * 60 * 60 - DDAY * 24 * 60 * 60 - DHR * 60 * 60 - DMT * 60);
                let t = {};
                ['DDAY', 'DHR', 'DMT', 'DSC'].forEach(q => { if (eval(q) > 0) { t[q] = eval(q); } });

                var dateKey = Object.keys(t);
                var temp = ""
                for (var i = 0; i < dateKey.length; i++) {
                    temp += t[dateKey[i]] + " ";
                    temp += this.getLanguage['MEM'][dateKey[i]] + " ";
                }
                return temp;
            },
            FormatNotifDate(date, selectedDate) {
                if (moment(date).format('DD MMM YYYY') == selectedDate) {
                    return true;
                } else {
                    return false;
                }
            },
            ctrPage(newValue) {
                this.int_Page = newValue;
                if (newValue > this.int_TP) {
                    this.int_Page = this.int_TP;
                }
                if (newValue <= 0) {//here set the limit of the label num
                    this.int_Page = 1;
                }
                this.int_IC = this.int_Page;
                this.getNotifList();
            },
            getNotifList() {
                this.bool_fullLoading = true;
                this.arry_setIsRead_List = [];
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.searchC != null && this.searchC != "") {
                    path += "&f.C=" + this.searchC;
                }

                this.getDataApi(`/api/anotif/l/u?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.slideinsearchfilter = false;
                        if (s) {
                            that.setNotifList(d.D);
                        }
                    });
            },
            setNotifList(returnD) {   // this out put at Notif.js and this output after get list
                this.arry_cl = returnD.Items;
                this.int_TP = returnD.TotalPages;
                this.int_TI = returnD.TotalItems;

                this.arry_cl.dateList = [];
                this.arry_cl.forEach((value, key) => {
                    if (!this.arry_cl.dateList.includes(moment(value.CTS).format('DD MMM YYYY'))) {
                        this.arry_cl.dateList.push(moment(value.CTS).format('DD MMM YYYY'));
                    }
                    //if (!this.ND_List.includes(moment(value.CTS).format('DD MMM YYYY'))) {
                    //    this.ND_List.push(moment(value.CTS).format('DD MMM YYYY'));
                    //}
                });

            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getNotifList();

            },
        },
        created() {
            this.getNotifList();
            this.searchC = this.$route.query.c;

        },
    }
</script>
<style>
    .card a {
        color: #636f83;
    }

    .contentWrapper {
        background: #fff;
        width: 100%;
        margin-top: 1rem;
    }

    .notif-time {
        position: absolute;
        right: 0;
        padding-right: 20px;
    }

    .notif-content-title {
        width: 85%;
    }

    body.marketingApp .card-unread {
        padding: 10px 15px 5px 15px !important;
        background: #2d3035 !important;
    }

</style>



// WEBPACK FOOTER //
// src/componentsGGEarn/Page/Notifications.vue